/**
 * Standalone module for the onboarding step enum.
 *
 * Kept separate from `Onboarding.tsx` so the router and auth guard (both in the
 * eager entry graph) can reference step values without statically importing the
 * heavy Onboarding page component — which would otherwise pull the page (and
 * everything it imports) into the initial bundle.
 */
export enum OnboardingStep {
  WELCOME = 'welcome',
  WORK_AREAS = 'work-areas',
  TEAM_INVITES = 'team-invites',
  CONNECT = 'connect',
  SLACK_SYNC = 'slack-sync',
  DISCOVER_FLOWS = 'discover-flows',
  EMAIL_SYNC = 'email-sync',
}
